import { initApi } from "@/utils/api.ts";
import { networkSignal } from "@/utils/signals";
import { Portfolio } from "@/api";

export function usePortfolioMutation() {
  const api = initApi();
  const mutation = networkSignal<Portfolio>({ retry: { delayMs: 1000, maxAttempts: 3 } });

  const updatePortfolio = async (portfolio: Pick<Portfolio, "title" | "description">) => {
    return await mutation.run(async () => await api.upsertPortfolio({ portfolio }));
  };

  return {
    mutate: updatePortfolio,
    ...mutation.signal,
  };
}
